"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addDefaultConsentCopy;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _constants = require("./constants");

var _fetchCompanyName = _interopRequireDefault(require("./fetchCompanyName"));

var _getDefaultConsentText = require("./getDefaultConsentText");

// Adds translated default consent copy for missing keys in the given settings object
function addDefaultConsentCopy(settings) {
  return (0, _fetchCompanyName.default)().then(function (companyName) {
    var newSettings = (0, _extends2.default)({}, settings);
    var consentCopy = {};

    _constants.LANGUAGES.forEach(function (lang) {
      consentCopy[lang] = {};

      _constants.CONSENT_FIELDS.forEach(function (field) {
        var settingsKey = field + ":" + lang;

        if (newSettings.hasOwnProperty(settingsKey)) {
          consentCopy[lang][field] = newSettings[settingsKey];
          delete newSettings[settingsKey];
        } else {
          consentCopy[lang][field] = (0, _getDefaultConsentText.getDefaultConsentTextWithCompanyName)(field, {
            locale: lang,
            companyName: companyName
          });
        }
      });
    });

    newSettings.consentCopy = consentCopy;
    return newSettings;
  });
}

module.exports = exports.default;